<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de acesso ao sistema">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/administracao/relatorio-acesso-sistema/List'

export default {
    components: {List},
}
</script>